import { useState, useEffect } from 'react';
import { api } from '../../service/api';
import {
  Dimmer,
  Loader,
  Table,
  Pagination,
  PaginationProps,
  Button,
} from 'semantic-ui-react';
import { getLink, getLocalTime } from '../../utils';
import { useSelector } from 'react-redux';

type ExecutionLogProps = {
  taskId: string;
};
const pageItems = 20;

const ExecutionLog = (props: ExecutionLogProps) => {
  const { taskId } = props;

  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const [isLoading, setIsLoading] = useState(true);
  const [executionLogs, setExecutionLogs] = useState<any[] | null>(null);
  const [activePage, setActivePage] = useState<string | number>(1);
  const [totalPages, setTotalPage] = useState(0);
  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    api
      .getExecutionLogs(taskId, parseInt(activePage.toString(), 10), pageItems)
      .then((res: any) => {
        setExecutionLogs(res.data.data);
        setTotalPage(Math.ceil(res.data.totalExecutionCount / pageItems));
        setIsLoading(false);
      });
  }, [taskId, activePage, refreshCount]);

  const handleRefresh = () => {
    setActivePage(1);
    setRefreshCount((count) => count + 1);
  };

  return (
    <div>
      {isLoading ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
            }}
          >
            <Button size="small" onClick={handleRefresh}>
              Refresh logs
            </Button>
          </div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Execution Id</Table.HeaderCell>
                <Table.HeaderCell>Statuses</Table.HeaderCell>
                <Table.HeaderCell>Last Status</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Timestamp</Table.HeaderCell>
                <Table.HeaderCell>Duration(Min)</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {executionLogs.map((el: any) => {
                return (
                  <Table.Row key={el.id}>
                    <Table.Cell>{el.ExecutionId}</Table.Cell>
                    <Table.Cell>
                      {Object.entries(el.Statuses).map(
                        ([status, time]: any[]) => {
                          return (
                            <p>
                              {status} -{' '}
                              {useLocalTime ? getLocalTime(time) : time}
                            </p>
                          );
                        }
                      )}
                    </Table.Cell>
                    <Table.Cell>{el.LastStatus}</Table.Cell>
                    <Table.Cell>{el.Status}</Table.Cell>
                    <Table.Cell>
                      {useLocalTime ? getLocalTime(el.createdAt) : el.createdAt}
                    </Table.Cell>
                    <Table.Cell>{el.Duration}</Table.Cell>
                    <Table.Cell>
                      <a
                        href={getLink(el.ExecutionId, el.createdAt)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button>View Logs</Button>
                      </a>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="3">
                  <Pagination
                    activePage={activePage}
                    totalPages={totalPages}
                    onPageChange={(e: any, data: PaginationProps) =>
                      setActivePage(data.activePage)
                    }
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </div>
      )}
    </div>
  );
};

export default ExecutionLog;
